import React from 'react';
import { DeleteActionWrapper } from './DeepAnalysisReviewResultModal.styles';
import { ReactComponent as EraseIcon } from './assets/erase-icon.svg';
import { PrimaryButton } from '../../../../common/components/buttons/NewButtons.styles';
import { ItemSelectedCheckbox, ItemSelectedCheckboxWrapper } from '../../../wealth/pages/class/components/ClassPage.styles';
import { ItemSelectedIcon } from '../../../wealth/pages/overview/components/items-list/ItemsListView';
import { CategoryField, NameField, ValueField } from './ReviewTableFields';
import { InstitutionField } from './InstitutionNameField';

export const ReviewAssetTableRow = ((props) => {
    let {
        currentItem,
        showMissingFieldsError,
        handleFieldChange,
        handleFundNameChange,
        isHoverOn,
        handleItemCategoryChange,
        handleAddNewItem,
        isEdited,
        relevantClasses,
        isNew,
        onClickDelete,
        showSkeleton,
        isInBulkEditMode,
        isItemForBulkEdit,
        itemIndex,
        onBulkEditChange
    } = props;

    return (
        <>
            <div style={{ display: 'flex', alignItems: 'center', padding: '12px 0px 12px 4px', width: '100%' }}>
                <ItemSelectedCheckboxWrapper
                    onClick={onBulkEditChange}
                    isSelected={isItemForBulkEdit}
                    isBulkEditMode={!isNew && (isInBulkEditMode || isHoverOn)}
                    defaultPadding={'12px 8px'}
                >
                    <ItemSelectedCheckbox isSelected={isItemForBulkEdit}>
                        {isInBulkEditMode && <ItemSelectedIcon />}
                    </ItemSelectedCheckbox>
                </ItemSelectedCheckboxWrapper>

                <NameField
                    value={currentItem?.item_name}
                    placeholder='New item'
                    onChange={(e) => handleFieldChange('item_name', e.target.value)}
                    bgColor={currentItem?.color}
                    icon={currentItem?.icon}
                    isEdited={isEdited}
                    isHoverOn={isHoverOn}
                    isNew={isNew}
                    showSkeleton={showSkeleton}
                    showMissingFieldsError={showMissingFieldsError && !isNew && !currentItem?.item_name}
                />

            </div>
            <div style={{ display: 'flex', alignItems: 'center', padding: '12px 0px' }}>

                <InstitutionField
                    key={`${itemIndex}_fund_name`}
                    value={currentItem?.fund_name}
                    handleFundNameChange={handleFundNameChange}
                    handleFieldChange={(val) => handleFieldChange('fund_name', val)}
                    isEdited={isEdited}
                    isHoverOn={isHoverOn}
                    isNew={isNew}
                    showSkeleton={showSkeleton}
                />

                <ValueField
                    isEdited={isEdited}
                    isHoverOn={isHoverOn}
                    isNew={isNew}
                    handleFieldChange={handleFieldChange}
                    currentItem={currentItem}
                    showSkeleton={showSkeleton}
                    value={currentItem?.amount}
                    currency={currentItem?.currency}
                    showCurrencyDropdown={true}
                    showMissingFieldsError={showMissingFieldsError && (isNaN(currentItem?.amount) || !currentItem?.currency)}
                />

                <CategoryField
                    currentItem={currentItem}
                    isEdited={isEdited}
                    isNew={isNew}
                    showSkeleton={showSkeleton}
                    showMissingFieldsError={showMissingFieldsError && !currentItem?.categoryId && !isNew}
                    onCategoryChange={handleItemCategoryChange}
                    relevantClasses={relevantClasses}
                />

                {
                    !isNew &&
                    <DeleteActionWrapper isEdited={isEdited} onClick={(e) => { onClickDelete(); e.stopPropagation() }}>
                        <EraseIcon />
                    </DeleteActionWrapper>
                }
                {
                    (isNew && isEdited) &&
                    <PrimaryButton onClick={handleAddNewItem} style={{ marginLeft: '16px' }}>Add</PrimaryButton>
                }
            </div>
        </>
    )
});
